import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-1',
  templateUrl: './1.component.html',
})
export class VbGeneral1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
